<template>
    <div class="mt-8 w-full h-full bg-white">
      <Statuses
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"/>
    </div>
  </template>

<script>

import Statuses from '../components/statuses/Statuses.vue';

export default {
  name: 'StatusView',
  data() {
    return {
      loading: false,
    };
  },
  components: {
    Statuses,
  },
  methods: {
    async fetchStatuses() {
      try {
        await this.$store.dispatch('SettingsModule/Statuses/fetchAllStatuses');
      } catch (e) {
        this.$notify.error({
          title: 'Error',
          message: 'Something went wrong please try again.',
        });
      }
    },
  },
  mounted() {
    this.loading = true;
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    this.fetchStatuses();
    this.loading = false;
  },
};
</script>

<style scoped></style>
